import { render, staticRenderFns } from "./newContract.vue?vue&type=template&id=520f2178"
import script from "./newContract.vue?vue&type=script&lang=js"
export * from "./newContract.vue?vue&type=script&lang=js"
import style0 from "./newContract.vue?vue&type=style&index=0&id=520f2178&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('520f2178')) {
      api.createRecord('520f2178', component.options)
    } else {
      api.reload('520f2178', component.options)
    }
    module.hot.accept("./newContract.vue?vue&type=template&id=520f2178", function () {
      api.rerender('520f2178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/marketplane/views/newContract.vue"
export default component.exports